import React, { useEffect } from "react";
import Star from "assets/images/svg/rate_s.svg";
import { useQueryClient } from "react-query";
import { FavIcon } from "components/favIcon";
import ServerImage from "components/server-image/server-image";
import { json, showDiscriminate } from "helpers/data";
import {
  create_Addons_wishList,
  create_app_wishList,
  delete_Addons_wishList,
  delete_app_wishList
} from "services/wishListServices";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ColoredLabel } from "components/classes";
import { useAuthContext } from "store/auth";

const FeatureCard = ({ id, application, title, logo, Label, isWishListed, info, content, price, rate }) => {
  const { t } = useTranslation("browse-apps");
  const [{ user }] = useAuthContext();
  const [favColor, setFavColor] = React.useState(isWishListed || false);

  useEffect(() => {
    setFavColor(isWishListed);
  }, [isWishListed]);

  const queryClient = useQueryClient();
  const handleFav = () => {
    setFavColor(!favColor);
    if (favColor) {
      application ? removeAppsWishList() : removeAddonsWishList();
    } else {
      application ? handleAppsWishList() : handleAddOnsWishList();
    }
  };
  const handleAppsWishList = () => {
    const data = { customerId: user.Id, ApplicationId: id };
    create_app_wishList(data)
      .then(({ response }) => {
        queryClient.invalidateQueries(["apps"]);
        if (response) toast.success(t("common:form.added"));
      })
      .catch();
  };
  const handleAddOnsWishList = () => {
    const data = { customerId: user.Id, addOnId: id };
    create_Addons_wishList(data)
      .then(({ response }) => {
        queryClient.invalidateQueries(["apps"]);
        if (response) toast.success(t("common:form.added"));
      })
      .catch();
  };
  const removeAppsWishList = () => {
    delete_app_wishList(id)
      .then(({ response }) => {
        queryClient.invalidateQueries(["apps"]);
        if (response) toast.success(t("common:form.removed"));
      })
      .catch();
  };
  const removeAddonsWishList = () => {
    delete_Addons_wishList(id)
      .then(({ response }) => {
        queryClient.invalidateQueries(["apps"]);
        if (response) toast.success(t("common:form.removed"));
      })
      .catch();
  };
  return (
    <div className="wishListCard">
      <button className="fav" onClick={handleFav}>
        <FavIcon color={favColor} />
      </button>
      <Link to={`../${application ? `app/${id}` : `addon-details/${id}`}`} className="card-link">
        <ServerImage className={"logo"} src={logo} />
        <h1 className="title">{json(title)}</h1>
        <span className="info">{json(info)}</span>
        <div className="especial">
          {Label ? <ColoredLabel color={Label.color}>{json(Label.name)}</ColoredLabel> : <></>}
          <div className="rate">
            <span className="number">{rate?.averageRate && <>{rate?.averageRate.toFixed(1) ?? 0}</>}</span>
            {rate?.averageRate && <img src={Star} alt="star" />}
            <span className="count">{rate?.count && <>({rate?.count ?? 0})</>} </span>
          </div>
        </div>
        <p className="content">{json(content)}</p>
        {price && (
          <span className="price">
            {t("filterBox.from")}{" "}
            <span>
              {price?.netPrice} {json(`${price?.currencySymbol}`)} / {json(`${showDiscriminate(`${price?.discrimination}`)} `)}
            </span>{" "}
          </span>
        )}
      </Link>

      <div className="za-actions">
        <Link to={application ? `/pricing-plans/${id}` : `/addon-details/${id}`} className="btn-White">
          {t("buyNow")}
        </Link>

        <a hidden={!application} href="https://mydexefstorage.blob.core.windows.net/admin/VersionDownload/DEXEFERP.exe"
           className="text-center text-decoration-none btn-blue">
          {t("myProducts.resleasePage.download")}
        </a>
      </div>
    </div>
  );
};

export default FeatureCard;
